import { Route, Routes } from "react-router-dom";
import "./App.css";
import "./Components/SiteComponants/CommonCss.css";
import Navbar from "./Components/Navbar/Navbar";
import { routeDatas } from "./Datas/RouteDatas/MainRoutes";
import FooterBottom from "./Components/FooterBottom/FooterBottom";
import { createContext, useEffect } from "react";
import Footer from "./Components/Footer/Footer";
import { dashboardRoutes } from "./Datas/RouteDatas/DashboardRoutes";
import { useSiteData } from "./Contexts/SiteContext";
import AllExtraComponantInOne from "./Components/SiteComponants/AllExtraComponantInOne";
import LoadingScreen from "./Components/SiteComponants/LoadingScreen";
export const ProductContext = createContext();
function App() {
  const { isloading, setIsLoading } = useSiteData();
  useEffect(() => {
    setIsLoading(false);
  }, []);
  console.log(isloading);
  return isloading ? (
    <LoadingScreen />
  ) : (
    <div className=" dark:dark-text">
      <AllExtraComponantInOne />
      <Navbar />
      <Routes>
        {/* all routes */}
        {routeDatas.map((route) => {
          return (
            route.visibility && (
              <Route key={route.route} path={route.route} element={route.child}>
                {route.route === "/dashboard" &&
                  dashboardRoutes.map((ot) => (
                    <Route key={ot.link} path={ot.link} element={ot.comp} />
                  ))}
              </Route>
            )
          );
        })}
      </Routes>
      <Footer />
      <FooterBottom />
    </div>
  );
}

export default App;
